import {Loner} from "../../Loner";
import {gsap} from "gsap";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {LonerGameMode} from "../../server/LonerGameMode";

export class LonerXBetReelView extends PIXI.Container {

    private readonly _betBoostAllowed: boolean;
    private xBetOneReelView: LonerXBetOneView;
    private xBetTwoReelView: LonerXBetOneView;

    constructor() {
        super();
        this._betBoostAllowed = Loner.apiPlugin.gameClientConfiguration.boostedBetAllowed;
        this.name = "LonerXBetReelView";
        if (this._betBoostAllowed) {
            this.init();
            this.addChild(this.xBetOneReelView, this.xBetTwoReelView);
        }
        Loner.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, () => this.onSelectedFeatureBetChanged());
        if (Loner.model.isRestore) {
            const mode: string = Loner.model.initData.mode,
                nextMode: string = Loner.model.initData.nextMode;
            if (!(mode.indexOf(LonerGameMode.NORMAL) > -1) || (mode === LonerGameMode.NORMAL && nextMode !== LonerGameMode.NORMAL)) {
                if (Loner.model.initData.boostedBetPlayed) {
                    if (Loner.model.featureName === "BOOSTED_BET") {
                        this.turnOnXBet(false);
                    } else {
                        this.turnOnXBet(true);
                    }
                    this.pauseRedDotBlinkTL();
                }
            }
        }

        if (Loner.apiPlugin.freeBets.hasFreeBets()) {
            this.turnOffXBet();
            Loner.apiPlugin.freeBets.events.once(Loner.apiPlugin.freeBets.FREE_BETS_END, () => {
                this.turnOffXBet();
            });
        }
        Loner.apiPlugin.freeBets.events.on(Loner.apiPlugin.freeBets.FREE_BETS_START, () => {
            this.turnOffXBet();
            Loner.apiPlugin.freeBets.events.once(Loner.apiPlugin.freeBets.FREE_BETS_END, () => {
                this.turnOffXBet();
            });
        });
    }

    public unPauseRedDotBlinkTL() {
        if (!this._betBoostAllowed) {
            return;
        }
        this.xBetOneReelView.unPauseRedDotBlink();
        this.xBetTwoReelView.unPauseRedDotBlink();
    }

    public turnOnXBet(bothXbetReels: boolean): void {
        if (!this._betBoostAllowed) {
            return;
        }
        const tl: gsap.core.Timeline = gsap.timeline();
        if (!this.xBetOneReelView.isToggled) {
            this.xBetOneReelView.playRedDotBlinkAnim();
        }
        if (bothXbetReels) {
            if (!this.xBetTwoReelView.isToggled) {
                this.xBetTwoReelView.playRedDotBlinkAnim();
            }
        }
    }

    public pauseRedDotBlinkTL(): void {
        if (!this._betBoostAllowed) {
            return;
        }
        this.xBetOneReelView.pauseRedDotBlink();
        this.xBetTwoReelView.pauseRedDotBlink();
    }

    public turnOffXBet(): void {
        if (!this._betBoostAllowed) {
            return;
        }
        this.xBetTwoReelView.stopRedDotBlinkAnim();
        this.xBetOneReelView.stopRedDotBlinkAnim();
    }

    private onSelectedFeatureBetChanged(): void {
        const activeBetFeature: BetFeature | undefined = Loner.apiPlugin.betFeatureController.getActiveBetFeature();
        if (!Loner.model.isRestore) {
            if (activeBetFeature?.name === "BOOSTED_BET") {
                this.turnOffXBet();
                this.turnOnXBet(false);
            } else if (activeBetFeature?.name === "BOOSTED_BET_2") {
                this.turnOffXBet();
                this.turnOnXBet(true);
            } else {
                this.turnOffXBet();
                if (!activeBetFeature?.name) {
                    Loner.model.featureName = "";
                }
            }
        }
    }

    private init(): void {
        this.xBetOneReelView = new LonerXBetOneView(true);
        this.xBetTwoReelView = new LonerXBetOneView(false);
    }
}

class LonerXBetOneView extends PIXI.Container {
    private _sideMarkCont: PIXI.Container;
    private _redBlinkingDot: PIXI.Sprite;
    private _toggled: boolean = false;
    private _blinkTl: gsap.core.Timeline | null;
    private _blinkTLpaused: boolean;
    private _reelId: number;

    constructor(isReelOne: boolean) {
        super();
        isReelOne ? this._reelId = 0 : this._reelId = 2;
        this.init(isReelOne);
        this.addChild(this._sideMarkCont, this._redBlinkingDot);
    }


    public playRedDotBlinkAnim(): void {
        if (!this._toggled) {
            this._toggled = true;
            this._blinkTl = gsap.timeline();
            this._blinkTl.add(this.showSideMarkAndDot(0.0001));
            this.startRedDotBlinking();
        }
        if (this._blinkTLpaused && this._blinkTl) {
            this._blinkTLpaused = false;
            this._blinkTl.play();
        }
        this._toggled = true;
    }

    public pauseRedDotBlink(): void {
        if (this._blinkTl && this._toggled) {
            this._blinkTLpaused = true;
            this._blinkTl.pause();
            this.visible = false;
        }
    }

    public unPauseRedDotBlink() {
        if (!this._blinkTLpaused) {
            return;
        }
        if (this._blinkTl) {
            this._blinkTLpaused = false;
            this._blinkTl.play();
            this.visible = true;
        }

    }

    public stopRedDotBlinkAnim(): void {
        if (this._toggled) {
            if (this._blinkTl) {
                this._blinkTl.progress(1);
                this._blinkTl.clear()
                this._blinkTl = null;
            }
            this.hideSideMarkAndDot(0.001);
        }
        this._toggled = false;
    }

    public showSideMarkAndDot(durr: number = 0.5): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._sideMarkCont.alpha = 0;
            this._redBlinkingDot.alpha = 0;
            this._sideMarkCont.visible = true;
            this._redBlinkingDot.visible = true;
        })
        tl.to([this._redBlinkingDot, this._sideMarkCont], {alpha: 1, duration: durr});
        return tl;
    }

    public hideSideMarkAndDot(durr: number = 0.5): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.to([this._redBlinkingDot, this._sideMarkCont], {alpha: 0, duration: durr});
        tl.add(() => {
            this._sideMarkCont.visible = false;
            this._redBlinkingDot.visible = false;
        })
        return tl;
    }

    private startRedDotBlinking(): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.to(this._redBlinkingDot, {alpha: 0.4, duration: 0.5});
        tl.to(this._redBlinkingDot, {alpha: 1, duration: 0.5});
        if (this._toggled) {
            tl.add(() => {
                this.startRedDotBlinking();
            })
        }
        if (this._blinkTl) {
            this._blinkTl.add(tl);
        }
    }

    private init(isReelOne: boolean): void {
        this._sideMarkCont = this.createSideMarkCont(isReelOne);
        this._redBlinkingDot = this.createRedBlinkingDot(isReelOne);
        this.hideSideMarkAndDot(0.001);
    }

    private createRedBlinkingDot(isReelOne: boolean): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("xbet/dot")[0]);
        sprite.name = "redDot";
        sprite.anchor.set(0.5);
        sprite.position.set(isReelOne ? 26 : 305, 147);
        return sprite;
    }

    private createSideMarkCont(isReelOne: boolean): PIXI.Container {
        const cont: PIXI.Container = new PIXI.Container();
        cont.name = "sideMarkCont";
        for (let idx: number = 0; idx < 4; idx++) {
            const sprite: PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures("xbet/side_mark")[0]);
            sprite.anchor.set(0.5);
            sprite.name = "sideMark" + idx;
            switch (idx) {
                case 0:
                    sprite.position.set(4, 0);
                    break;
                case 1:
                    sprite.position.set(isReelOne ? 101.4 : 113.4, 0);
                    sprite.angle = 90;
                    break;
                case 2:
                    sprite.position.set(4, 347);
                    sprite.angle = -90;

                    break;
                case 3:
                    sprite.position.set(isReelOne ? 101.4 : 113.4, 347);
                    sprite.angle = -180;

                    break;
            }
            cont.addChild(sprite);
        }
        cont.position.set(isReelOne ? 24 : 300, 150);
        return cont;
    }

    get isToggled(): boolean {
        return this._toggled;
    }
}